import React, {Component} from 'react';
import ReactApexChart from "react-apexcharts";

class ServingCategoriesDonutFull extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                chart: {
                    height: 250,
                    type: 'donut',
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'center',
                    show: true,
                },
                colors: ['#CCCCFF', '#AAAAFF', '#6666FF','#4D4DFF','#3333FF', '#23238E', '#191970', '#000033'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                stroke: {
                    show: false,
                    width: 0
                },
                labels: this.props.categories
            },
            series: this.props.percentages,

        };
    }

    componentDidUpdate(prevProps,prevState) {
        if(prevProps.chartValue !== this.props.chartValue) {

            this.setState({
                options: {
                    chart: {
                        height: 250,
                        type: 'donut',
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'center',
                        show: true,
                    },
                    colors: ['#CCCCFF', '#AAAAFF', '#6666FF','#4D4DFF','#3333FF', '#23238E', '#191970', '#000033'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                    stroke: {
                        show: false,
                        width: 0
                    },
                    labels: this.props.categories
                },
                series: this.props.percentages,
            })
        }
        
    }

    render() {
        return (
            <div>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="donut"
                    height="330px"
                />
            </div>
        );
    }
}

export default ServingCategoriesDonutFull;
